export const THEME = {
  primary: 'var(--primary-color)',
  secondary: 'var(--color-secondary)',

  success: 'var(--color-success)',
  warning: 'var(--color-warning)',
  danger: 'var(--color-danger)',

  background: 'var(--color-bg)',
  surface: 'var(--color-surface)',

  textPrimary: 'var(--color-text-primary)',
  textSecondary: 'var(--color-text-secondary)',

  greenButton: 'var(--color-green)',
};
